/**
 * App title bar — back button (history.back / configurable fallback).
 * Used by collection listing and search results.
 */
(function (global) {
  const root = global.document;
  if (!root) return;

  function resolveFallback(nav) {
    const fromAttr = String((nav && nav.getAttribute('data-offhoo-back-fallback')) || '').trim();
    if (fromAttr) return fromAttr;
    const routes = global.Theme && global.Theme.routes;
    return (routes && routes.collections_url) || '/collections';
  }

  function bindBack(nav) {
    const back = nav.querySelector('[data-offhoo-collection-back]');
    if (!back || back.dataset.offhooCollectionBackReady === 'true') return;
    back.dataset.offhooCollectionBackReady = 'true';

    back.addEventListener('click', (event) => {
      event.preventDefault();
      if (global.history.length > 1) {
        global.history.back();
        return;
      }
      global.location.href = resolveFallback(nav);
    });
  }

  function boot() {
    root.querySelectorAll('[data-offhoo-collection-app-nav]').forEach(bindBack);
  }

  if (root.readyState === 'loading') {
    root.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
